import React from 'react'
import PropTypes from 'prop-types'
import Button from '@material-ui/core/Button'
import Typography from '@material-ui/core/Typography'
import { CoachingCenterWaiverContent } from 'components/waivers/cc-waiver'
import CoachingCenterAgreeSection from 'components/waivers/cc-agree-section'
import useStyles from './styles'

const WaiverStep = ({ form, handlePrev, onSubmit }) => {
  const classes = useStyles()
  const { handleSubmit, setValue, getValues } = form

  const handleContinue = () => {
    setValue('agreeWaiver', !!getValues('agreeWaiver'), {
      shouldValidate: true,
    })
    handleSubmit(onSubmit)()
  }

  return (
    <div className={classes.card}>
      <Typography variant="h6" component="h2" className={classes.sectionTitle}>
        Assumption of risk, waiver and release of liability
      </Typography>
      <div className={classes.waiverBody} tabIndex={0}>
        <CoachingCenterWaiverContent showHeader={false} />
      </div>
      <div className={classes.waiverAgree}>
        <CoachingCenterAgreeSection
          form={form}
          handleClick={handleContinue}
          buttonClassName={classes.primaryButton}
          leadingAction={
            <Button className={classes.textButton} onClick={handlePrev}>
              Back
            </Button>
          }
        />
      </div>
    </div>
  )
}

WaiverStep.propTypes = {
  form: PropTypes.object.isRequired,
  handlePrev: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
}

export default WaiverStep
